import React, { useEffect, useState, useRef } from "react";
import { Table, Input } from "antd";
import { getApmcApplicationDetails, getApplications, getPanelApplications, submitApmcApproveRejectApplication, submitApmcFiles } from "../auth/services/privateapicalling";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { label } from "yet-another-react-lightbox/*";
import CommonSelect from "../pages/license-registration-form/CommonSelect";
import CommonStatusSelect from "../application/CommonSelect";
import { Option } from "../application/CommonSelect";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";

interface StatusProp {
  status: any[];
  navigateTo?: string;

}



const ApplicationTable: React.FC<StatusProp> = ({ status, navigateTo }) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const [Selections, setSelections] = useState<boolean>(true);
  const [applicationData, setApplicationData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(5); // Default limit
  const [totalItems, setTotalItems] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [licenseUploaded, setLicenseUploaded] = useState(false);
  const [selectedApplicationId, setSelectedApplicationId] = useState<string | null>(null);
  const [schemeApplicationId, setSchemeApplicationId] = useState<string | null>(null);
  const [selectedStatus, setSelectedStatus] = useState<Option | null>(status[0]);
  const language = useSelector((state: any) => state.auth.language);
  const token = useSelector((state: any) => state.auth.token);
  const userDetail = useSelector((state: any) => state.auth.userDetails)
  const roleIdentifier = userDetail.Role.Role_Identifier;
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const navigate = useNavigate();
  const [isModalClose , setIsModalClose] = useState(false)
  const debounceTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [signedDocUploaded, setSignedDocUploaded] = useState<boolean>(false);
  const [comment, setComment] = useState("");
  const onSelectChange = (newSelectedRowKeys: any[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setSelectedFile(event.target.files[0]); // Store the selected file
      handleUploadSingnedDoc(event.target.files[0])
    }
  };
  const handleUploadSingnedDoc = async (file: any) => {
    // setLicenseUploaded(true);

    try {
    

      const formData = new FormData();
      formData.append("file", file as Blob);
      formData.append("documentName", "license");
      formData.append("applicationId", selectedApplicationId);
      formData.append("schemeId", schemeApplicationId);

      const res = await submitApmcFiles(formData, token);
      // setLicenseUploaded(false);

      if (res.success == true) {
        setSelectedFile(null);
      toast.success(res?.message || "File uploaded successfully", {
          position: "top-right",
        });
        setSignedDocUploaded(true);
      } else {
        toast.error(res?.message || "File upload failed. Please try again.", {
          position: "top-right",
        });
      }
    } catch (error) {
     
    }
  }
  const handleSubmit = async (status: string, appStatusLevel: string) => {
    if(!signedDocUploaded){
      toast.error("Please upload the file or wait until the file is uploaded.", {
        position: "top-right"
      });
      return;
    }

    setLicenseUploaded(true)


    try {
      const submitFormData = {
        status: status,
        appStatusLevel: appStatusLevel,
        applicationId: selectedApplicationId,
        schemeId: schemeApplicationId,
        applicationType: "scheme",
        comment: comment

      };



      const submitData = await submitApmcApproveRejectApplication(submitFormData, token);
    


      if (submitData.success) {
        setLicenseUploaded(false);
      
        let successMessage = "";
        if (submitData.data.status === "reject") {
          successMessage = "Query raised successfully!";
          toast.warning(successMessage, { position: "top-right" });
        } else if (submitData.data.status === "permanentReject") {
          successMessage = "Application permanently rejected!";
          toast.error(successMessage, { position: "top-right" });
        } else if (submitData.data.status === "approvedUnsigned") {
          successMessage = "Application approved successfully!";
          toast.success(successMessage, { position: "top-right" });
        } else {
          successMessage = "Form submitted successfully!";
          toast.success(successMessage, { position: "top-right" });
        }
               setIsModalClose(true);
         setTimeout(() => {
        window.location.reload();
      }, 200);
      } else {
        toast.error("Submission failed. Please try again.", {
          position: "top-right"
        });
      }

    } catch (error) {
    
      toast.error("An error occurred during submission.", {
        position: "top-right"
      });
    } finally {
      setLicenseUploaded(false)
    }
  };

  const columns = [
    {
      title: language.application_id,
      dataIndex: "applicationId",
      render: (text: string) => (
        <h6 className="fw-medium">
          <Link to="#">{text}</Link>
        </h6>
      ),
    },
      { title: language.district, dataIndex: "district" },
    { title: language.apmc_name, dataIndex: "apmc" },
  
    {
      title: "Scheme",
      dataIndex: "schem",
      render: (text: string) => (
        <OverlayTrigger
          placement="bottom"
          overlay={
            <Tooltip id={`tooltip-scheme-${text}`}>
              {text}
            </Tooltip>
          }
        >
          <div
            style={{
              maxWidth: 200,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              cursor: "pointer",
            }}
          >
            {text}
          </div>
        </OverlayTrigger>
      ),
    },


    {
      title: language.applied_date,
      dataIndex: "appliedDate",
      render: (date: string) => {
        if (!date) return "NA";
        const d = new Date(date);
        return isNaN(d.getTime()) ? "NA" : d.toLocaleDateString("en-GB");
      }, // "DD/MM/YY"
    },
    {
      title: language.application_status,
      dataIndex: "status",
      render: (status: string) => {
        const statusMapping: Record<string, string> = {
          permanentReject: "Permanent reject",
          approvedUnsigned: "Approve Unsigned",
          reject: "Raised Query",
          pending: "Pending",
          resubmission: "Resubmission",
          draft: "Draft",
          approve: "Approved"

        };

        return <span>{statusMapping[status] || status}</span>;
      },
    },

    {
      title: language.action,
      dataIndex: "applicationId",
      render: (text: string, record: any) =>
        record.action ? ( // Only show button if record.action is true
          (record.status === "pending" && record?.appStatusLevel==="pendingAtHigherAuthorityApproval") ? (
            <>
              <h6 className="fw-medium">
                <button
                  className="bg-success rounded text-white px-4 py-2"
                  onClick={() =>
                    navigate("/district", {
                      state: {
                        applicationId: record.applicationId,
                        id: record.schemeId,
                      },

                    })
                  }
                >
                  {language.review}
                </button>
              </h6>
              {roleIdentifier === "SC" && <Link
                to="#"
                className="btn  btn-info btn-sm"
                data-bs-toggle="modal"
                data-inert={true}
                data-bs-target="#upload-sealed-license"
                onClick={() => {
                  setSelectedApplicationId(record.applicationId)
                  setSchemeApplicationId(record.schemeId)
                }
                }
              >
                Upload Signed License
              </Link>}
            </>) :
            <h6 className="fw-medium">
              <button
                className="bg-info rounded text-white px-4 py-2"
                onClick={() =>
                  navigate(navigateTo  ||"/district", {
                    state: {
                      applicationId: record.applicationId,
                      id: record.schemeId,
                    },

                  })
                }
              >
                {language.view}

              </button>
            </h6>) : (
          (record.status === "pending"  && selectedStatus?.value==="pendingAtHigherAuthorityApproval") ? (
            <>
              <h6 className="fw-medium">
                <button
                  className="bg-primary rounded text-white px-4 py-2"
                  onClick={() =>
                    navigate("/district", {
                      state: {
                        applicationId: record.applicationId,
                        id: record.schemeId,
                      },

                    })
                  }
                >

                  {language.view}
                </button>
              </h6>
              {roleIdentifier === "SC" && <Link
                to="#"
                className="btn  btn-info btn-sm"
                data-bs-toggle="modal"
                data-inert={true}
                data-bs-target="#upload-sealed-license"
                onClick={() => {
                  setSelectedApplicationId(record.applicationId)
                  setSchemeApplicationId(record.schemeId)
                }
                }
              >
                Upload Signed License
              </Link>}
            </>) :
            <h6 className="fw-medium">
              <button
                className="bg-primary rounded text-white px-4 py-2"
                onClick={() =>
                  navigate(record.status === "reject" ? "/schemes-query-district" : "/district", {
                    state: {
                      applicationId: record.applicationId,
                      id: record.schemeId,
                    },

                  })
                }
              >

                {language.view}
              </button>
            </h6>),
    }
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const type = "scheme";


  const fetchApplication = async (
    page: number,
    searchApplicationById: string = "",
    limit: number,
    status?: string
  ) => {
    setLoading(true);
    try {
      // If status is empty string or undefined/null, use 'all'
      const statusToSend = !status ? 'all' : status;
      const appdata = await getApmcApplicationDetails(
        statusToSend,
        token,
        page,
        searchApplicationById,
        limit,
        type
      );
      //.log("Fetched Data:", appdata);

      if (appdata?.success) {
        setApplicationData(appdata.data || []);
        setTotalItems(appdata.totalCount || 0);
      }
    } catch (error) {
      //.error("Error fetching applications:", error);
    } finally {
      setLoading(false);
    }
  };


  const handleSelectChange = (option: Option | null) => {
    setSelectedStatus(option);
    setCurrentPage(1); // Reset to first page when status changes
    fetchApplication(1, searchQuery, limit, option?.value);
  };

  const handleSearch = (value: string) => {
    setSearchQuery(value);

    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      fetchApplication(1, value, limit, selectedStatus?.value);
      setCurrentPage(1);
    }, 500);
  };


  useEffect(() => {
    fetchApplication(currentPage, searchQuery, limit, selectedStatus?.value);
  }, [currentPage, status, limit]);

  return (
    <>

      <div className="table-top-data">
        <div className="row p-3">
          <div className="col-sm-12 d-flex justify-content-end">
            <CommonStatusSelect
              options={status}
              value={selectedStatus} // Use value instead of defaultValue
              onChange={handleSelectChange}
              className="w-25 custom-select me-4"
            />

            <Input
              placeholder="Search Application Id..."
              value={searchQuery}
              onChange={(e) => handleSearch(e.target.value)}
              style={{ width: 250 }}
              allowClear
            />
          </div>
        </div>
      </div>


      <Table
        className="table datanew dataTable no-footer"
        // rowSelection={Selections ? rowSelection : undefined}
        columns={columns}
        rowKey={"applicationId"}
        rowHoverable={false}
        dataSource={applicationData}
        loading={loading}
        pagination={{
          locale: { items_per_page: "" },
          nextIcon: <i className="ti ti-chevron-right" />,
          prevIcon: <i className="ti ti-chevron-left" />,
          pageSize: limit,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "30"],
          current: currentPage,
          total: totalItems,
          showTotal: (total, range) =>
            `Showing ${range[0]} - ${range[1]} of ${total} entries`,
          onChange: (page, pageSize) => {
            setCurrentPage(page);
            setLimit(pageSize);
          },
        }}
      />
      <div className="modal fade" id="upload-sealed-license">
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">{language.usl}</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">{language.upf}</label>
                      <input
                        type="file"
                        className="form-control"
                        accept="application/pdf"
                        onChange={handleFileUpload}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <textarea
                        className={`form-control `}
                        style={{ fontSize: '1rem' }}
                        rows={2}
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        placeholder="Enter your remarks here. *"
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  {language.can}
                </button>
                <button
                  type="button"
                  // data-bs-dismiss="modal"
                  disabled={licenseUploaded}
                  className="btn btn-info me-2"
                  onClick={() => {
                    handleSubmit("approve", "schemeGranted")
                  }}
                   {...(isModalClose ? { "data-bs-dismiss" : "modal" } : {})}
                >
                  {licenseUploaded ?  <i className="ion-load-a ion-spin"></i>  :language.approve}
                </button>
                <button
                  type="button"
                  // data-bs-dismiss="modal"
                  disabled={licenseUploaded}
                  className="btn btn-primary"
                  onClick={() => {
                    handleSubmit("permanentReject", "applicationRejected")
                  }}
                 {...(isModalClose ? { "data-bs-dismiss" : "modal" } : {})}
                >
                {  licenseUploaded ?  <i className="ion-load-a ion-spin"></i>  :"Reject"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={3000} />
    </>
  );
};

export default ApplicationTable;
